// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._8S6P4q6q1\\+r0J1 {\n  position: absolute;\n  top: 0;\n  bottom: 10px;\n  right: 10px;\n  left: 10px;\n  border-radius: 3px;\n}\n._8S6P4q6q1\\+r0J1.mnKs9vmneSEnXQ {\n  left: calc(16px + 10px);\n}\n._8S6P4q6q1\\+r0J1 > div {\n  border-radius: 3px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "_8S6P4q6q1+r0J1",
	"collapsedWorkspaceNavigation": "mnKs9vmneSEnXQ"
};
export default ___CSS_LOADER_EXPORT___;
